import { useState, useCallback } from 'react';

const useColumnSort = (initialField = '', initialDirection: 'asc' | 'desc' = 'asc') => {
    const [sortField, setSortField] = useState(initialField);
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>(initialDirection);

    const onColumnSort = useCallback((field: string) => {
        if (sortField === field) {
            if (sortDirection === 'asc') {
                setSortDirection('desc');
            } else {
                setSortField('');
                setSortDirection('asc');
            }
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    }, [sortField, sortDirection]);

    return { sortField, sortDirection, onColumnSort };
};

export default useColumnSort;
